import React, { useEffect, useState } from "react";
import {
    BoxSearchSubText,
    ListContainer,
    ListSearchResultsWrapper,
    SearchFallbackStyled,
} from "./SearchFallback.styles";
import { SearchFallbackProps } from "./SearchFallback.types";
import { searchByContent } from "../../../../Infrastructure/Services/ContentSearchService";
import { Content } from "../../../Pages/GroupDetailsPage/Components/Modals/ContentSearchModal/SearchContent/ContentResultList/ContentListItem/ContentListItem.types";
import { ContentType } from "./ContentListItem/ContentListItem.types";
import { DividerCustom } from "./ContentListItem/ContentListItem.styles";
import { ContentListItem } from "./ContentListItem/ContentListItem";
import { useGlobalConfigs } from "../../../../Infrastructure/Hooks/useGlobalConfigs";
import { splitSearchValue } from "../../../../Infrastructure/Helpers/StringHelper";

const SEARCH_LIMIT = 10;

export const SearchFallback: React.FC<SearchFallbackProps> = ({
    excludePostId,
    groupId,
    searchQuery,
}) => {
    const { getConfigs } = useGlobalConfigs();
    const searchVariant = getConfigs()?.contentSearchOnInputVersion ?? "v1";
    const [searchResults, setSearchResults] = useState<Content[]>([]);
    const searchFallbackLimit =
        getConfigs()?.maxFallbackContentSearch ?? SEARCH_LIMIT;

    const explodedSearchQuery = splitSearchValue(searchQuery);

    useEffect(() => {
        (async () => {
            try {
                const newSearchResults = await searchByContent(
                    searchQuery,
                    groupId,
                    excludePostId,
                    searchVariant,
                    searchFallbackLimit,
                );
                setSearchResults(newSearchResults);
            } catch {
                setSearchResults([]);
            }
        })();
    }, [searchQuery, groupId, excludePostId, searchFallbackLimit]);

    const navigateToContent = (content: Content) => {
        switch (content.contentType) {
            case ContentType.POST:
                console.log(
                    "navigate to PostDetailsPageIndexUrl post id ",
                    content.id,
                );
                break;
            case ContentType.COMMENT:
                console.log(
                    "navigate to PostDetailsWithPinnedCommentPageIndexUrl comment id ",
                    content.id,
                );
                break;
        }
    };

    if (!searchResults.length) {
        return null;
    }

    return (
        <>
            <SearchFallbackStyled>
                <ListSearchResultsWrapper>
                    <ListContainer>
                        <BoxSearchSubText>Ähnliche Beiträge</BoxSearchSubText>
                        {searchResults.map((content, index) => {
                            return (
                                <>
                                    <ContentListItem
                                        key={`post-fallback-search-${content.id}`}
                                        onItemClick={() =>
                                            navigateToContent(content)
                                        }
                                        content={content}
                                        stringsToHighlight={explodedSearchQuery}
                                    />
                                    {index < searchResults.length - 1 && (
                                        <DividerCustom variant="inset" />
                                    )}
                                </>
                            );
                        })}
                    </ListContainer>
                </ListSearchResultsWrapper>
            </SearchFallbackStyled>
        </>
    );
};
